// @commons
const apiURLBuilder = require('core/apiURLBuilder');

const {
    ACCOUNT_BENEFITS_DATA_SUCCESS,
    ACCOUNT_BENEFITS_DATA_REQUEST,
    ACCOUNT_BENEFITS_DATA_FAILURE
} = require('constants/contactCenter/actionTypes');
const apiRequestHelper = require('utilities/APIRequestHelper');

const requestBenefits123DataInProgress = () => ({
    type: ACCOUNT_BENEFITS_DATA_REQUEST
});

const requestBenefits123DataSuccess = payload => ({
    type: ACCOUNT_BENEFITS_DATA_SUCCESS,
    payload
});

const requestBenefits123DataFailure = error => ({
    type: ACCOUNT_BENEFITS_DATA_FAILURE,
    payload: {
        error
    }
});

const queryBenefits123Data = (accountId) => (dispatch, getState) => {
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const accountOne = immAccount.getIn(['ibanComplex', 'codbban']);

    dispatch(requestBenefits123DataInProgress());
    return apiRequestHelper.APIGet(
        dispatch,
        apiURLBuilder.getURL('queryBenefits123Data'),
        {
            query: {
                accountOne,
            },
        }
    )
    .then( response => {
        if (!!response.error) {
            dispatch(requestBenefits123DataFailure(response.error));
        } else {
            dispatch(requestBenefits123DataSuccess(response));
        }
    })
    .catch(response => dispatch(requestBenefits123DataFailure(response.error)));
};

module.exports = {
    queryBenefits123Data
};
